import type { ChatSettings } from '../services/types/serviceSettingTypes';
import copilotSettingsStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export function getChatSettings(mailboxInfo: MailboxInfo): ChatSettings | undefined {
    const store = copilotSettingsStore(mailboxInfo);
    return store.chatSettings;
}
